import { ENV } from '@/constants';
import { CampaignProgressBar } from './CampaignProgressBar';
import { ShareOptions } from './ShareOptions';
import { OpportunityIconChip } from './OpportunityIconChip';
import { getOpportunityTypeNameFromValue } from 'src/util/getOpportunityType';
import { appImgPath } from '@/util';

interface CampaignPreviewHeaderProps {
  title: string;
  shortId: string;
  openingDate: string;
  closingDate: string;
  opportunityTypesSought: number[];
  headerImage: {
    url: string;
    attribution?: string;
  };
}
export default function CampaignPreviewHeader({
  title,
  shortId,
  openingDate,
  closingDate,
  opportunityTypesSought,
  headerImage,
}: CampaignPreviewHeaderProps) {
  return (
    <div className="flex flex-col items-start gap-4 sm:gap-6">
      <div className="flex justify-start flex-col gap-4 sm:gap-6 sm:pb-2 items-start sm:flex-row sm:justify-between sm:items-center w-full ">
        <div className="bg-general-neutral-lighter p-1 border border-outline-neutral-light rounded-md h-fit text-center text-body-md shadow-light-down leading-highlights-lg text-content-secondary">
          Campaign Preview
        </div>
        <ShareOptions title={title} shortId={shortId} source={ENV.NEXT_PUBLIC_ORGANISATION_NAME} />
      </div>
      <div className="flex flex-col gap-4 sm:gap-6 w-full">
        <h1 className="p-0 leading-8 text-headline-h1">{title}</h1>
        <div className=" flex items-center gap-4">
          <CampaignProgressBar openingDate={openingDate} closingDate={closingDate} />
        </div>
        {/* opportunity types being sought */}
        <div className="flex flex-col items-start gap-2">
          <p className="text-content-secondary text-body-lg leading-highlights-lg">Opportunity types being sought:</p>
          {opportunityTypesSought && opportunityTypesSought.length > 0 ? (
            <div className="flex items-center gap-2 flex-wrap">
              {opportunityTypesSought.map(type => {
                const typeKey = getOpportunityTypeNameFromValue(type);
                return (
                  <OpportunityIconChip
                    className="shadow-light-down border text-highlights-md leading-4 border-action-outline-secondary-enabled line-clamp-none min-w-fit flex gap-1 w"
                    type={typeKey}
                    key={type}
                  />
                );
              })}
            </div>
          ) : null}
        </div>

        <figure className="mb-3.5 flex justify-center items-center">
          <img
            width={600}
            src={appImgPath(headerImage.url, {
              name: 'thumbnail',
              params: {
                width: 600,
                quality: 70,
              },
            })}
            className="rounded-md object-cover"
            alt="Header"
          />
        </figure>
      </div>
    </div>
  );
}
